import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { ResponsiveBar } from "@nivo/bar";
import { format } from "date-fns";

import * as APIDashboard from "../../../services/nps/functions";

import {
  data,
  data02,
  data03,
  indicatorsMap,
  indicatorsMap02,
  classificationZoneOneData,
  classificationZoneTwoData,
} from "./dataSet/dataSet";
import AgeGroup from "./Age-Group/ageGroup";
import Notes from "./Notes/notes";

import { ReactComponent as HamburgerIcon } from "../../../build/images/icons/hamburger.svg";

import "./indicators.css";
import HorizontalStackedChart from "../HorizontalStackedChart";
import Loading from "../../Loading";

export default function Indicators() {
  const filtersDashboard = useSelector((state) => state.npsfilters);

  const formattedData = data.reduce((acc, current, index) => {
    const gender = index % 2 === 0 ? "Male" : "Female";
    const newData = { ...current, id: index, gender };
    acc.push(newData);
    return acc;
  }, []);
  const [activeButton, setActiveButton] = useState("promoter");
  const [dataGeneral, setDataGeneral] = useState([]);
  const [dispareFilter, setDispareFilter] = useState(false);
  const [dataIndicators, setDataIndicators] = useState([]);
  const [isLoadingDataIndicators, setIsLoadingDataIndicators] = useState(false);

  function renderIndicators(dataIndicators) {
    if (isLoadingDataIndicators) {
      return (
        <div className="container-graphics03-loading">
          <Loading.Paperplane />
        </div>
      );
    }

    const hasDataIndicators = !!dataIndicators && dataIndicators.length > 0;
    if (hasDataIndicators) {
      return (
        <section className="container-graphics03">
          {dataIndicators.map((indicatorInfo, index) => {
            return (
              <div key={index} className="container-graphics03__item">
                <HorizontalStackedChart
                  title={indicatorInfo.title}
                  subtitle={indicatorInfo.subtitle}
                  data={indicatorInfo.data}
                  subqualifiers={indicatorInfo.subqualifiers}
                  isTooltippyActive={false}
                  isScrollActive={true}
                />
              </div>
            );
          })}
        </section>
      );
    }

    return null;
  }

  async function getDataToIndicators(dateStart, dateEnd, units, business) {
    setIsLoadingDataIndicators(true);
    const formatedInitialDate = format(new Date(dateStart), "yyyy-MM-dd");
    const formatedFinalDate = format(new Date(dateEnd), "yyyy-MM-dd");
    let unitsIds = "";
    const hasUnits = !!units && units.length > 0;
    if (hasUnits) {
      unitsIds = units.map((unit) => unit.id).join(",");
    }
    let businessId = "";
    const hasBusiness = !!business && business.length > 0;
    if (hasBusiness) {
      businessId = business.map((data) => data.id).join(",");
    }

    let updatedDataIndicators = [];

    const response = await APIDashboard.indicatorsGeneralPdf(
      formatedInitialDate,
      formatedFinalDate,
      unitsIds,
      businessId
    );

    const hasResponse = !!response && response.status === 200;
    if (hasResponse) {
      const rawDataIndicators = response.data;
      const hasRawDataIndicators =
        !!rawDataIndicators && rawDataIndicators.length > 0;
      if (hasRawDataIndicators) {
        updatedDataIndicators = rawDataIndicators.map((indicator) => {
          const resultNumber = Number(indicator.resultado);
          let goodPercent = 0;
          let badPercent = 0;
          const isResultNumberANumber = typeof resultNumber === "number";
          if (isResultNumberANumber) {
            goodPercent = resultNumber;
            badPercent = 100 - resultNumber;
          }

          let good = 0;
          let bad = 0;
          try {
            const asnwers = JSON.parse(indicator.respostas);
            const hasAnswers = !!asnwers && asnwers.length > 0;
            if (hasAnswers) {
              asnwers.forEach((answer) => {
                const isGood =
                  answer.resposta === "Bom" ||
                  answer.resposta === "bom" ||
                  answer.color === "green";
                if (isGood) {
                  good = good + answer.qtde;
                } else {
                  bad = bad + answer.qtde;
                }
              });
            }
          } catch (error) {
            console.log("Erro ao realizar o PARSE: ", error);
          }
          let total = good + bad;

          let subqualifiers = [];
          let rawSubqualifiers = null;
          try {
            const parsedRawSubqualifiers = JSON.parse(
              indicator.subqualificadores
            );
            rawSubqualifiers = parsedRawSubqualifiers;
          } catch (error) {
            console.log("erro ao realizar o parse: ", error);
          }
          const hasRawSubqualifiers =
            !!rawSubqualifiers && rawSubqualifiers.length > 0;
          if (hasRawSubqualifiers) {
            subqualifiers = rawSubqualifiers.map((sub, index) => {
              return {
                label: sub.subqualificador,
                value: sub.qtde,
                id: index,
              };
            });
          }

          const hasSubqualifiers = !!subqualifiers && subqualifiers.length > 0;
          if (hasSubqualifiers) {
            subqualifiers.sort((a, b) => b.value - a.value);
          }

          return {
            data: {
              good,
              bad,
              total,
              goodPercent,
              badPercent,
            },
            subqualifiers,
            title: indicator.pergunta,
            subtitle: "Subqualificadores",
          };
        });
      }
    }

    setDataIndicators(updatedDataIndicators);
    setIsLoadingDataIndicators(false);
  }

  async function getIndicatorsGeneral() {
    const response = await APIDashboard.indicatorsGeneral(
      format(new Date(filtersDashboard.datestart), "yyyy-MM-dd"),
      format(new Date(filtersDashboard.dateend), "yyyy-MM-dd"),
      filtersDashboard.units.map((option) => option.id).join(),
      filtersDashboard.business.map((option) => option.id).join()
    );

    if (response && response.status === 200) {
      const data = response.data;

      const dataFormated = data.map((datum) => {
        const respostas = JSON.parse(datum.respostas);
        return {
          name: datum.pergunta,
          data: respostas,
        };
      });

      // dataFormated.push({
      //   name: "Tempo de espera",
      //   data: [
      //     { resposta: "Bom", qtde: 7 },
      //     { resposta: "Ruim", qtde: 3 },
      //   ],
      // });

      setDataGeneral(dataFormated);
      setDispareFilter(true);
    } else {
      console.log(
        "Falha, não foi possível carregar as informações!",
        "Verifique sua conexão e tente novamente mais tarde."
      );
    }
  }

  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  const renderChartCards = (data) => {
    return data.map((item, index) => (
      <div className="chart-card" key={index}>
        <header className="chart-card__header">
          <h5 className="chart-card__header__h5">{item.name}</h5>

          {/* <button className="chart-card__header__button">
            <HamburgerIcon />
          </button> */}
        </header>

        <div className="chart-card__graphic">
          <ResponsiveBar
            data={item.data}
            keys={["qtde"]}
            indexBy="resposta"
            padding={0.8}
            margin={{ top: 16, right: 0, bottom: 5, left: 0 }}
            colors={({ id, data, index }) => {
              if (data.color === "red") {
                return "#E94235"; // RED
              } else {
                return "#008908"; // GREEN
              }
            }}
            axisLeft={{
              tickSize: 5,
              tickPadding: 5,
              tickRotation: 0,
            }}
            borderRadius={4}
            enableGridY={false}
            enableLabel={false}
            axisBottom={null}
          />
        </div>

        <div className="chart-card-indicators">
          {item.data.map((data, index) => {
            return (
              <span
                className={data.color === "red" ? "bad" : "good"}
                key={index}
              >
                <div
                  className={
                    data.color === "red" ? "bad__color" : "good__color"
                  }
                />

                <h6 className={data.color === "red" ? "bad__h6" : "good__h6"}>
                  {data.resposta} ({data.qtde})
                </h6>
              </span>
            );
          })}
          {/* {item.data[0] && (
            <span className="good">
              <div className="good__color" />

              <h6 className="good__h6">
                {item.data[0].resposta} ({item.data[0].qtde})
              </h6>
            </span>
          )}

          {item.data[1] && (
            <span className="bad">
              <div className="bad__color" />

              <h6 className="bad__h6">
                {item.data[1].resposta} ({item.data[1].qtde})
              </h6>
            </span>
          )} */}
        </div>
      </div>
    ));
  };

  const generateAgeData = () => {
    const maleData = Array.from({ length: 16 }, (_, index) => ({
      ageGroup: `${index * 10}-${(index + 1) * 10}`,
      male: -Math.floor(Math.random() * 100),
    }));

    const femaleData = Array.from({ length: 16 }, (_, index) => ({
      ageGroup: `${index * 10}-${(index + 1) * 10}`,
      female: Math.floor(Math.random() * 100),
    }));

    return [...maleData, ...femaleData];
  };

  const ageData = generateAgeData();

  useEffect(() => {
    //getIndicatorsGeneral();
  }, []);

  useEffect(() => {
    if (filtersDashboard.active && dispareFilter) {
      // getIndicatorsGeneral();
    }
    if (filtersDashboard.active) {
      getDataToIndicators(
        filtersDashboard.datestart,
        filtersDashboard.dateend,
        filtersDashboard.units,
        filtersDashboard.business
      );
    }
  }, [filtersDashboard]);

  return (
    <>
      <section className="container-graphics01">
        <AgeGroup />

        <Notes />
      </section>

      {renderIndicators(dataIndicators)}

      <section className="container-graphics02">
        {/* {renderChartCards([
          ...classificationZoneOneData,
          ...classificationZoneTwoData,
        ])} */}
        {/*renderChartCards(dataGeneral)*/}

        {/* <div className="classification-zone-two">
          {renderChartCards(classificationZoneTwoData)}
        </div> */}
      </section>
    </>
  );
}
